<div class="left-nav">
  <div class="arrow-left">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <polygon
        fill="#8493A9"
        points="2 16.769 3.231 18 10 11.231 16.769 18 18 16.769 11.231 10 18 3.231 16.769 2 10 8.769 3.231 2 2 3.231 8.769 10"
      ></polygon>
    </svg>
  </div>
  <ul>
    <li class="nav-group" aria-hidden="true">Play</li>
    <li [class.active]="activePath === 'char-portfolio' || activePath === 'player-detail'">
      <a (click)="pagenavigation('char-portfolio')">
        <i><img src="assets/icons/nav-player.svg" alt="" aria-hidden="true" /></i>
        Player
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </li>

    <li [class.active]="activePath === 'activegames' || activePath === 'game-master-detail'">
      <a (click)="pagenavigation('activegames')">
        <i><img src="assets/icons/nav-game-master.svg" alt="" aria-hidden="true" /></i>
        Game Master
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.39062 1.41052L8.39062 8.39052L1.39062 15.4105" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </li>

    <li class="nav-group" aria-hidden="true">Create</li>
    <li [class.active]="activePath === 'maplist' || activePath === 'map-modify'">
      <a (click)="pagenavigation('maplist')">
        <i><img src="assets/icons/nav-maps.svg" alt="" aria-hidden="true" /></i>
        Maps
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.39062 1.41052L8.39062 8.39052L1.39062 15.4105" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </li>

    <li [class.active]="activePath === 'content-creator' || activePath === 'add-edit-content'">
      <a (click)="pagenavigation('content-creator')">
        <i><img src="assets/icons/nav-content-vault.svg" alt="" aria-hidden="true" /></i>
        Content Vault
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.39062 1.41052L8.39062 8.39052L1.39062 15.4105" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </li>

    <li class="nav-group" aria-hidden="true">Explore</li>
    <li [class.active]="activePath === 'store'">
      <a (click)="openStore()">
        <i><img src="assets/icons/nav-store.svg" alt="" aria-hidden="true" /></i>
        Store
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.39062 1.41052L8.39062 8.39052L1.39062 15.4105" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </li>

    <li [class.active]="activePath === 'social-feed'">
      <a (click)="pagenavigation('social-feed', true)">
        <i><img src="assets/icons/nav-social-feed.svg" alt="" aria-hidden="true" /></i>
        Social Feed
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.39062 1.41052L8.39062 8.39052L1.39062 15.4105" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </li>

    <li [class.active]="activePath === 'wiki'">
      <a (click)="pagenavigation('wiki')">
        <i><img src="assets/icons/nav-wiki.svg" alt="" aria-hidden="true" /></i>
        Wiki
        <svg
          *ngIf="navigatingPath !== 'wiki'"
          width="10"
          height="17"
          viewBox="0 0 10 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.39062 1.41052L8.39062 8.39052L1.39062 15.4105"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span *ngIf="navigatingPath === 'wiki'" class="nav-mini-spinner"></span>
        <button type="button" class="wiki-expand-indicator" *ngIf="activePath === 'wiki'"
          [class.is-closed]="!wikiTreeOpen" (click)="toggleWikiTree($event)"
          [attr.aria-expanded]="wikiTreeOpen" [title]="wikiTreeOpen ? 'Hide the wiki contents' : 'Show the wiki contents'">
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </a>
    </li>
    <!-- Category tree expands downward in the same column, below "Wiki" —
         it's the last item, so this never pushes other rows out of place,
         and the rail's own overflow-y:auto lets it scroll as one column
         instead of floating a separate panel over the page content. -->
    <li *ngIf="activePath === 'wiki'" class="wiki-tree-slot" [hidden]="!wikiTreeOpen">
      <ng-content select="[wiki-tree]"></ng-content>
    </li>
  </ul>

  <div class="rail-footer">
    <nav class="rail-links" aria-label="Help and policies">
      <a (click)="pagenavigation('FAQ')">FAQ</a>
      <a (click)="pagenavigation('terms-of-service')">Terms</a>
      <a (click)="pagenavigation('privacy-policy')">Privacy</a>
      <a href="mailto:support@worldtumbler.com">Help</a>
    </nav>
    <p class="rail-copy">&copy; {{ year }} WorldTumbler</p>
  </div>
</div>
